import React, { Component } from "react";
import Pagination from "./Pagination";
import "../../assets/css/additional.css";
import NoDataImg from "../../assets/images/NoData.webp";
import AgentAvatar from "../AgentAvatar";

//******* Note
//these 11 key names for tableRows array elements should be same always i.e.
//clmTwoWidth={"eg. w-20, w-1/2 etc."}
// ImgSrc:"",
// Label1: "",
// PillTxt:"",
// PillClr:"red(example)",
// Status: "0 for cancelled 1 for active and empty for nothing",
// DescriptionClm1: "",
// Label2: "",
// DescriptionClm2: "",
// Value: "" Its second last column of the table, can be used with sorting too as done in pendingProposal.jsx
//" ": <div><buton></button></div> last column heading is mandtory can be used for any button if required as
//done in pendingProposal.jsx or the rows can be left empty

const TableComponent = (props) => {
  //   state = {};

  //   componentWillMount() {}

  const tableHeadingFn = (ths) => {
    return ths.map((th, index) => {
      if (index === 0) {
        return (
          <th
            key={`tableHead-1-${index}`}
            className="thSticky h-5  pl-4 pr-4 py-3 border-b border-gray-200 dark:border-gray-600 text-left text-sm leading-4 font-semibold tracking-wider"
          >
            {th}
          </th>
        );
      } else if (index === 1) {
        return (
          <th
            key={`tableHead-2-${index}`}
            className="thSticky h-5  pl-1 pr-2 py-3 border-b border-gray-200 dark:border-gray-600 text-left text-sm leading-4 font-semibold tracking-wider"
          >
            {th}
          </th>
        );
      } else if (index === props.tableHeadings.length - 2) {
        return (
          <th
            key={`tableHead-3-${index}`}
            className="thSticky h-5  px-2 whitespace-no-wrap py-3 border-b dark:border-gray-600 border-gray-200  text-right text-sm leading-4 font-semibold tracking-wider"
          >
            {th}
          </th>
        );
      } else {
        return (
          <th
            key={`tableHead-4-${index}`}
            className="thSticky h-5  px-2 py-3 border-b border-gray-200 dark:border-gray-600 text-center text-sm leading-4 font-semibold tracking-wider"
          >
            {th}
          </th>
        );
      }
    });
  };

  const otherRowElements = (trElements) => {
    // console.log("testing", trElements);
    let headings = [...props.tableHeadings];
    let e = [];

    let color = "gray-900";

    headings.map((th, index) => {
      if (index > 1) {
        if (index === headings.length - 2) {
          let numericStr = trElements.Value.replace(/[^\d.-]/g, "");
          let dataItem = parseFloat(numericStr);

          if (dataItem < 0) {
            color = "red-500";
          } else {
            color = "gray-900";
          }
          e.push(
            <td
              key={`tableData-4-${trElements.Value}-${index}`}
              className={
                `px-2 py-3 border-b border-gray-200  dark:border-gray-600 text-right text-xs leading-4 whitespace-no-wrap text-${color} dark:text-${color == "gray-900" ? "white" : color}`
              }
            >
              {trElements.Value.replace("$-", "-$")}
            </td>
          );
        } else {
          e.push(
            <td
              key={`tableData-4-${trElements[th]}-${index}`}
              className={
                `px-3 py-3 border-b dark:border-gray-600 border-gray-200 text-center text-xs leading-4 whitespace-no-wrap text-${color} dark:text-${color == "gray-900" ? "white" : color}`
              }
            >
              {trElements[th]}
            </td>
          );
        }
      }
    });

    return e;
  };

  const otherSmallViewElements = (trElements) => {
    let headings = [...props.tableHeadings];
    let e = [];
    let color = "gray-900";

    headings.map((th, index) => {
      if (index > 1 && index < headings.length - 1) {
        if (index === headings.length - 2) {
          let numericStr = trElements.Value.replace(/[^\d.-]/g, "");
          let dataItem = parseFloat(numericStr);

          if (dataItem < 0) {
            color = "red-500";
          } else {
            color = "gray-900";
          }
          e.push(
            <tr key={`tableRow-5-${dataItem}-${index}`}>
              <th className="w-35vh px-2 py-1 border-r border-gray-200 text-left text-xs leading-4 font-medium text-gray-600  dark:border-gray-600  dark:text-white tracking-wider">
                {th}
              </th>
              <td
                className={
                  "w-65vh px-2 py-2 dark:text-gray-200 text-left text-xs leading-4 whitespace-no-wrap text-" +
                  color
                }
              >
                <div className="mr-2 grid grid-cols-2">
                  <div>{trElements.Value.replace("$-", "-$")}</div>
                  <div className="">{trElements[" "]}</div>
                </div>
              </td>
            </tr>
          );
        } else {
          e.push(
            <tr key={`tableRow-6-${th}-${index}`}>
              <th className="w-35vh px-2 py-2 rounded-md  dark:border-gray-600  dark:text-white border-r border-gray-200 text-left text-xs leading-4 font-medium text-gray-600  tracking-wider">
                {th}
              </th>
              <td
                className={
                  "w-65vh px-2 py-1 dark:text-gray-200 text-left text-xs leading-4 whitespace-no-wrap text-" +
                  color
                }
              >
                {trElements[th]}
              </td>
            </tr>
          );
        }
      }
    });

    return e;
  };

  const renderStatus = (txt, clr) => {
    if (txt) {
      let color = clr;
      return (
        <span
          className={
            "inline-flex ml-0.5 text-xs font-semibold rounded-full bg-" +
            color +
            "-200 text-gray-700 dark:text-gray-200"
          }
        >
          {txt}
        </span>
      );
    }
  };

  const tableRowClr = (index) => {
    if (index === 0) {
      return "bg-white hover:bg-gray-100 dark:bg-[#1c1c1c] hover:dark:bg-[#2a2a2a]";
    } else if (index % 2 === 0) {
      return "bg-white hover:bg-gray-100 dark:bg-[#1c1c1c] hover:dark:bg-[#2a2a2a]";
    } else if (index % 2 != 0) {
      return "bg-gray-50 hover:bg-gray-100 dark:bg-[#252525] hover:dark:bg-[#2f2f2f]";
    }
  };

  const previousPageFn = () => {
    const { setPageIndexFn } = props;

    let oldfirstRowIndex = parseInt(props.firstRowIndex);
    let lastRowIndex = oldfirstRowIndex - 1;
    if (lastRowIndex > 0) {
      let newFirstRowIndex = oldfirstRowIndex - props.numberOfElementsPerPage;

      setPageIndexFn(newFirstRowIndex, lastRowIndex);
    }
  };

  const nextPageFn = () => {
    const { setPageIndexFn } = props;

    let oldLastRowIndex = parseInt(props.dataLength) - 1;
    let firstRowIndex = parseInt(props.lastRowIndex);
    let lastRowIndex = firstRowIndex + props.numberOfElementsPerPage;
    let newFirstRowIndex = firstRowIndex + 1;
    if (lastRowIndex > oldLastRowIndex) {
      lastRowIndex = oldLastRowIndex;
    }

    if (newFirstRowIndex <= oldLastRowIndex) {
      setPageIndexFn(newFirstRowIndex, lastRowIndex);
    }
  };

  const firstPageFn = () => {
    const { setPageIndexFn } = props;
    let lastRowIndex = props.numberOfElementsPerPage - 1;
    setPageIndexFn(0, lastRowIndex);
  };

  const lastPageFn = () => {
    const { setPageIndexFn } = props;
    let dataLength = parseInt(props.dataLength);
    let multiplier = parseInt(dataLength / props.numberOfElementsPerPage);
    let firstRowIndex = multiplier * props.numberOfElementsPerPage;
    let lastRowIndex = dataLength - 1;
    setPageIndexFn(firstRowIndex, lastRowIndex);
  };

  const loadTable = () => {
    let tableRows = [...props.tableRows];
    let tableHeadings = [...props.tableHeadings];

    return (
      <div className="w-full">
        <div
          className="relative mb-4 align-middle rounded-md inline-block w-full shadow sm:rounded-t-lg"
        >
          {tableRows.length === 0 && !props.loader ? (
            <div className="flex flex-col rounded-md bg-white items-center dark:bg-white/5 justify-center py-20 text-gray-600">
              <img src={NoDataImg} alt="No data" className="w-40 h-auto mb-4" />
              <h2 className="text-xl font-semibold dark:text-white">No Data to Display</h2>
              <p className="text-sm text-gray-500 mt-1 dark:text-gray-400">Try resetting filters or changing your criteria.</p>
            </div>
          ) : (
          <>
            <div className="hidden xl:block bg-white dark:bg-white/10 scroll max-h-[50vh] overflow-hidden overflow-y-auto">
              <table className="w-full h-full">
                <thead className="text-sm sticky top-0 z-5 text-gray-600 uppercase border-b dark:border-gray-600 w-full dark:text-white dark:bg-black bg-white">
                  <tr className="bg-white/20">{tableHeadingFn(tableHeadings)}</tr>
                </thead>
                <tbody className="bg-white dark:bg-white/5">
                  {tableRows.map((trElements, index) => (
                    <tr
                      key={`tablerow-${trElements["Enrolment Number"]}-${index}`}
                      className={tableRowClr(index)}
                    >
                      <td className="pl-3 pr-5 py-4 border-b dark:border-gray-600 border-gray-200 w-1/4">
                        <div className="flex items-center ">
                          <div className="grid grid-col-1 ">
                            <AgentAvatar nameKey={trElements.Label1} />
                            <div className="mt-1">
                              {renderStatus(
                                trElements.PillTxt,
                                trElements.PillClr
                              )}
                            </div>
                          </div>
                          <div className="ml-2">
                            <div className="text-sm leading-5 text-gray-900 dark:text-white">
                              {trElements.Label1}
                            </div>
                            <div className="text-xs leading-5 text-gray-500 dark:text-gray-300">
                              {trElements.DescriptionClm1}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td
                        className={
                          props.clmTwoWidth +
                          " pl-1 pr-3 border-b dark:border-gray-600 border-gray-200"
                        }
                      >
                        <div className="text-sm leading-5 text-gray-900 dark:text-white">
                          {trElements.Label2}
                        </div>
                        <div className="text-xs leading-5 whitespace-nowrap text-gray-500 dark:text-gray-300">
                          {trElements.DescriptionClm2}
                        </div>
                      </td>

                      {otherRowElements(trElements)}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <table className="xl:hidden w-full space-y-2 rounded-md">
              {tableRows.map((trElements, index) => (
                <div
                  key={`tablerow-2-${trElements["Enrolment Number"]}-${index}`}
                  className={"mb-2 bg-white shadow-md dark:bg-white/10"}
                >
                  <tr>
                    <th
                      className={
                        "w-35vh px-2 py-2 bg-white border-b border-gray-100 dark:bg-white/5 text-left text-xs font-medium text-gray-600"
                      }
                    >
                      <div className="items-center flex gap-2">
                          <AgentAvatar nameKey={trElements.Label1} size={35} textClass="text-sm" />
                        <div className="mt-1">
                          {renderStatus(trElements.PillTxt, trElements.PillClr)}
                        </div>
                      </div>
                    </th>
                    <td className={"w-65vh bg-white border-b border-gray-100 dark:bg-white/5 text-right"}></td>
                  </tr>
                  <tr>
                    <th className="w-35vh px-2 py-2 border-r border-gray-200 dark:border-gray-600  dark:text-white text-left text-xs leading-4 font-medium text-gray-600  tracking-wider">
                      {tableHeadings[0]}
                    </th>
                    <td className="w-65vh px-2 py-2 dark:text-gray-200">
                      <div className="flex items-center ">
                        <div className="">
                          <div className="text-xs leading-5 font-medium text-gray-900 dark:text-gray-300">
                            {trElements.Label1}
                          </div>
                          <div className="text-xs leading-5 text-gray-500 dark:text-gray-300">
                            {trElements.DescriptionClm1}
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th className="w-35vh px-2 py-2  text-left text-xs border-r border-gray-200  dark:border-gray-600  dark:text-white leading-4 font-medium text-gray-600  tracking-wider">
                      {tableHeadings[1]}
                    </th>
                    <td className="w-65vh px-2 py-2 dark:text-gray-200">
                      <div className="text-xs  leading-5 text-gray-900 dark:text-gray-300">
                        {trElements.Label2}
                      </div>
                      <div className="text-xs leading-5  text-gray-500 dark:text-gray-200">
                        {trElements.DescriptionClm2}
                      </div>
                    </td>
                  </tr>
                  {otherSmallViewElements(trElements)}
                </div>
              ))}
            </table>
            <Pagination
              numberOfElementsPerPage={props.numberOfElementsPerPage}
              lengthOfData={props.dataLength}
              lengthOfTableRows={props.tableRows.length}
              filterOn={props.filterOn}
              previousPageFn={() => previousPageFn()}
              firstPageFn={() => firstPageFn()}
              lastPageFn={() => lastPageFn()}
              nextPageFn={() => nextPageFn()}
              firstRowIndex={props.firstRowIndex}
              lastRowIndex={props.lastRowIndex}
            />
          </>
        )}
      </div>
    </div>
    );
  };

  return loadTable();
};

export default TableComponent;
